import * as types from '../mutation-types'
import { api } from '@/modules/api'
import tokenService from '../../../plugins/tokenService'
import router, { homePath, loginPath } from '../../router'
import decodeJWT from '@/utils/decodeJWT'

const state = {
  isLoggedIn: !!tokenService.getAccessToken(),
  scopes: [],
  accessToken: tokenService.getAccessToken()
}

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  getAccessToken: state => state.accessToken,
  userScopes: state => state.scopes,
  getIsManager: state => (!state.scopes.includes('super_admin') && !state.scopes.includes('master')),
  getIsMaster: state => (!state.scopes.includes('super_admin') && state.scopes.includes('master')),
  getIsSuperUser: state => state.scopes.includes('super_admin'),
  isDeveloper: state => state.scopes.includes('dev_email_templates'),
  getUserRole: (state, getters) => {
    const userRoles = [
      {roleName: 'master', roleStatus: getters.getIsMaster},
      {roleName: 'manager', roleStatus: getters.getIsManager},
      {roleName: 'super_admin', roleStatus: getters.getIsSuperUser}
    ]
    return userRoles.find(role => (role.roleStatus === true)).roleName
  }
}

const actions = {
  async authenticateUser ({ commit }, user) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.post(api.auth.login(), user)
      // fetch email template if log in is successed
      commit(types.SET_AUTH_TOKENS, data)
      if (data.accessToken) {
        await this.dispatch('fetchEmailTemplates')
      }
      commit(types.SET_SPINNER_STATUS, false)
      router.push(homePath)
      return data
    } catch (err) {
      commit(types.SET_SPINNER_STATUS, false)
      commit(types.CREATE_ERROR_MESSAGE)
      throw err
    }
  },
  refreshTokenAction ({ commit }, data) {
    commit(types.SET_AUTH_TOKENS, data)
  },
  deuthenticateUser ({ commit }) {
    commit(types.LOG_OUT_USER)
    router.push(loginPath)
  },
  decodeUserScopes ({ commit, state }) {
    commit(types.UPDATE_ACCESS_TOKEN)
    if (state.accessToken) {
      commit(types.SET_USER_SCOPES, decodeJWT(state.accessToken).header.scopes)
    }
  },
  async submitNewPassword ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.auth.setPassword(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Your password was successfully changed')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE)
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async requestPasswordReset ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.auth.sendSetPasswordLink(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'We send you link for restore password! Plese check your email.')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE)
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_AUTH_TOKENS] (state, token) {
    const { accessToken, refreshToken } = token
    state.isLoggedIn = true
    state.accessToken = accessToken
    tokenService.setAccessToken(accessToken)
    tokenService.setRefreshToken(refreshToken)
  },
  [types.LOG_OUT_USER] (state) {
    state.isLoggedIn = false
    state.scopes = []
    state.accessToken = ''
    tokenService.removeAccessToken()
    tokenService.removeRefreshToken()
  },
  [types.SET_USER_SCOPES] (state, scopes) {
    state.scopes = scopes
  },
  [types.UPDATE_ACCESS_TOKEN] () {
    this.accessToken = tokenService.getAccessToken()
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js